export const SIEMENS_DEFAULT_COMPONENT_DESCRIPTIONS = [
    'Meterpreis horizontale Schiene ohne Abgang',
    'Mehrpreis Vertikalverlegung',
    'Mehrpreis Richtungsänderungen 90°',
    'Mehrpreis Verteilereinspeisung AC',
    'Mehrpreis Brandschutz EI90',
] as const;
